import {
  useState, useEffect, useRef,
} from 'react';
import moment from 'moment';

import InsiderSvc from '../../../../../services/dbServices/InsiderSvc';

import Investors from './Investors';
import ChangeInvestors from './ChangeInvestors';

const InvestorsHolder = (props) => {
  const { companyNumber, isWatchlist } = props;

  let mounted = true;
  const initialized = useRef(false);
  const [totalInvestorsValue, setTotalInvestorsValue] = useState({});
  const [currentInvestorsData, setCurrentInvestorsData] = useState({
    loading: true,
    data: [],
  });
  const [currentHistoricalData, setCurrentHistoricalData] = useState({
    loading: true,
    data: [],
  });

  const callAPI = () => {
    const params = {
      company_number: companyNumber,
    };

    InsiderSvc.getCompanyInsiderInvestorHolders(params)
      .then((res) => {
        if (!mounted) {
          return;
        }

        initialized.current = true;

        const totalObj = {
          valueOfHoldings: 0,
        };
        (res?.currentInvestors || []).forEach((item) => {
          ['valueOfHoldings'].forEach((field) => {
            totalObj[field] += Number(item[field]);
          });
        });

        setTotalInvestorsValue(totalObj);
        setCurrentInvestorsData({
          loading: false,
          data: (res?.currentInvestors || []).sort((a, b) => (b.numberOfShares - a.numberOfShares)),
        });

        const historicalInvestors = [res?.currentInvestors || []];
        historicalInvestors.push(...(res?.historicalInvestors || []));
        let newHistoricalData = [];
        const currentYearHeader = [];

        for (let i = 0; i < historicalInvestors.length; i += 1) {
          const currentArr = historicalInvestors[i];
          for (let j = 0; j < currentArr.length; j += 1) {
            const currentObj = currentArr[j];
            const currentYear = moment(currentObj.CS01filingDate, 'YYYY-MM-DD').format('YYYY');
            if (currentYear && !currentYearHeader.includes(currentYear)) {
              currentYearHeader.push(currentYear);
            }
            const dataIndex = newHistoricalData
              .findIndex((f) => f.investorId === currentObj.investorId
              && f.classOfShares === currentObj.classOfShares);
            const extraData = {
              [`year_${currentYear}_numberOfShares`]: currentObj.numberOfShares,
              [`year_${currentYear}_annualPercentageChangeInNumberOfShares`]: currentObj.annualPercentageChangeInNumberOfShares,
            };
            if (dataIndex > -1) {
              newHistoricalData[dataIndex] = {
                ...newHistoricalData[dataIndex],
                ...extraData,
              };
            } else {
              newHistoricalData.push({
                ...currentObj,
                ...extraData,
              });
            }
          }
        }

        const sortedCurrentYearHeader = currentYearHeader
          .sort((a, b) => (a > b ? -1 : Number(a !== b))).slice(0, 5);

        if (sortedCurrentYearHeader.length) {
          newHistoricalData = newHistoricalData
            .sort((a, b) => (b[`year_${sortedCurrentYearHeader[0]}_numberOfShares`] - a[`year_${sortedCurrentYearHeader[0]}_numberOfShares`]));
        }

        setCurrentHistoricalData({
          loading: false,
          data: newHistoricalData,
          currentYearHeader: sortedCurrentYearHeader,
        });
      });
  };

  useEffect(() => {
    setTimeout(() => {
      callAPI({ pageSize: 10, currentPage: 1 });
    }, 200);

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div>
      <Investors
        currentData={currentInvestorsData}
        setCurrentData={setCurrentInvestorsData}
        totalValue={totalInvestorsValue}
        isWatchlist={isWatchlist}
      />
      <ChangeInvestors
        currentData={currentHistoricalData}
        setCurrentData={setCurrentHistoricalData}
        isWatchlist={isWatchlist}
      />
    </div>
  );
};

export default InvestorsHolder;
